import Vue from 'vue';
import Router from 'vue-router';
import Start from './views/Start.vue';
import Test from './views/Test.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: {
        name: 'start',
      },
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
    },
  ],
});
